/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./game-difficulty-legend.vue?vue&type=template&id=58962f86&scoped=true&"
import script from "./game-difficulty-legend.vue?vue&type=script&lang=js&"
export * from "./game-difficulty-legend.vue?vue&type=script&lang=js&"
import style0 from "./game-difficulty-legend.vue?vue&type=style&index=0&id=58962f86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58962f86",
  null
  
)

export default component.exports